<template>
<div class="ew-page">
  <navbar-dashboard name="Monedero"></navbar-dashboard>

  <div class="ew-page__body">
    <section class="ew-card ew-wallet-summary">
      <div class="ew-wallet-summary__info">
        <p class="ew-wallet-summary__label">Saldo disponible</p>
        <p class="ew-wallet-summary__value">{{ formatMXN(total_monedero) }} <span>MXN</span></p>
      </div>
      <router-link class="ew-btn-primary" to="/prepaid/new">
        <ph-icon name="plus" />
        Recargar saldo
      </router-link>
    </section>

    <section class="ew-card">
      <div class="table-responsive">
        <div class="ew-loading" v-if="dataLoading">
          <span class="ew-spinner"></span>
          <p class="ew-loading-text">Cargando movimientos…</p>
        </div>
        <table class="ew-table" v-else-if="prepaids.length > 0">
          <thead>
            <tr>
              <th scope="col">Fecha</th>
              <th scope="col">Folio</th>
              <th scope="col">Movimiento</th>
              <th scope="col">Monto</th>
              <th scope="col">Estatus</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, i) in prepaids" v-bind:key="i">
              <td>{{ formatDateTime(p.created_at) }}</td>
              <td>{{ p.numberOfOrder }}</td>
              <td>{{ movementLabel(p) }}</td>
              <td>{{ formatMXN(p.amount) }}</td>
              <td>
                <span class="ew-badge" :class="p.status ? 'ew-badge--success' : 'ew-badge--pending'">
                  {{ p.status ? 'Pagado' : 'Pendiente' }}
                </span>
              </td>
              <td class="ew-table__actions">
                <button v-if="p.status == false" class="ew-table__link-btn ew-table__link-btn--danger" @click="removePrepaid(p._id)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ew-empty" v-else>
          <ph-icon name="wallet" />
          <p class="ew-empty__title">Aún no tienes movimientos</p>
          <p class="ew-empty__text">Recarga tu monedero para pagar tus envíos más rápido.</p>
          <router-link class="ew-btn-primary" to="/prepaid/new">Recargar saldo</router-link>
        </div>
      </div>

      <div class="ew-pagination" v-if="totalPages > 1">
        <button class="ew-pagination__btn" :disabled="page <= 1" @click="goToPage(page - 1)">Anterior</button>
        <button
          class="ew-pagination__btn"
          @click="goToPage(p)"
          v-for="p in availablePages"
          :key="p"
          :class="{ 'is-active': page === p }"
        >{{ p }}</button>
        <button class="ew-pagination__btn" :disabled="page >= totalPages" @click="goToPage(page + 1)">Siguiente</button>
      </div>
    </section>
  </div>
</div>
</template>

<script>
import Navbar from './Header/Navbar'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import api from '../commons/api'
import axios from 'axios'
import moment from 'moment'
import commons from '../commons'
import { formatMXN } from '../commons/currency'
import VueConfirmDialog from 'vue-confirm-dialog'
import Vue from 'vue'
import PhIcon from './icons/PhIcon'

Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

export default {
  name: 'ListPrepaid',
  data () {
    return {
      user_id: '',
      prepaids: [],
      total_monedero: 0,
      isOpen: false,
      results: [],
      scroll:0,
      isLoading: false,
      dataLoading: true,
      arrowCounter: -1,
      page: 1,
      limit: 20,
      totalCount: 0,
    }
  },
  created () {
    this.user_id = localStorage.getItem('ew-user-id')
    this.getPrepaidsUser()
    this.setItemActive('prepaids')
  },
  mounted(){

  },
  beforeDestroy(){

  },
  methods: {
   formatMXN,
   ...mapMutations(['setItemActive']),

   movementLabel (p) {
     return p.type != 'Pago sobrepeso' ? (p.shipment == null ? 'Abono' : 'Cargo') : p.type
   },
   formatDateTime(value) {
     if (value) {
       return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
     }
   },
   getPrepaidsUser () {
     this.dataLoading = true
     // Fase 3, punto 5 del plan de monedero: el tope fijo de 1000 (sin
     // paginación) le escondía a la cuenta grande todo su historial
     // anterior sin ningún indicio. El backend ahora pagina de verdad
     // (page/limit + totalCount), mismo patrón que Users.vue.
     axios
       .get(`${commons.apiURL}/api/v1/prepaid`, {
         params: { user: this.user_id, page: this.page, limit: this.limit }
       })
       .then(response => {
           this.prepaids = response.data.prepaids
           this.totalCount = response.data.totalCount
       })
       .catch(error => {
         console.error(error)
       })
       .finally(() => {
         this.dataLoading = false
       })
     // El saldo viene del servidor (suma completa dentro de Mongo), nunca de
     // la lista paginada de arriba — esa solo alimenta la tabla.
     axios
       .get(`${commons.apiURL}/api/v1/prepaid/getTotalAmount/${this.user_id}`)
       .then(response => {
           this.total_monedero = parseFloat(response.data.total_amount) || 0
       })
       .catch(error => {
         console.error(error)
       })
   },
   goToPage (page) {
     if (page < 1 || page > this.totalPages) return
     this.page = page
     this.getPrepaidsUser()
   },
   removePrepaid(id)
   {
     this.$confirm({
       title: '¿Está seguro?',
       message: '¿Está seguro de eliminar este movimiento?',
       button: {
         yes: 'Sí',
         no: 'Cancelar'
       },
       callback: confirm => {
         if (confirm) {
           axios
             .delete(`${commons.apiURL}/api/v1/prepaid/${id}`)
             .then(response => {
                 if(response.status == 200)
                 {
                    this.getPrepaidsUser()
                 }
             })
             .catch(error => {
               console.error(error)
             })
         }
       }
     })
   },

  },
  computed: {
   ...mapGetters(['itemActive']),
   totalPages () {
     return Math.ceil(this.totalCount / this.limit) || 1
   },
   availablePages () {
     const result = []
     const initial = this.page > 1 ? this.page - 1 : 1
     const final = this.page < this.totalPages ? this.page + 1 : this.totalPages
     for (let i = initial; i <= final; i++) {
       result.push(i)
     }
     return result
   }
  },
  components: {
    'navbar-dashboard': Navbar,
    'ph-icon': PhIcon
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-page { @include app-tokens; }
.ew-page__body { padding: 1.75rem 2rem 2.5rem; display: flex; flex-direction: column; gap: 1.25rem; }

.ew-card { @include ew-card; }

.ew-wallet-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.5rem 1.75rem;
}
.ew-wallet-summary__label {
  margin: 0 0 0.35rem;
  font-family: var(--app-font);
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--app-muted);
}
.ew-wallet-summary__value {
  margin: 0;
  font-family: var(--app-mono);
  font-size: 2rem;
  font-weight: 700;
  color: var(--app-navy);

  span {
    font-family: var(--app-font);
    font-size: 0.95rem;
    font-weight: 700;
    color: var(--app-muted);
  }
}

.ew-btn-primary { @include ew-btn-primary; }

.ew-table { @include ew-table; }
.ew-loading { @include ew-loading; }
.ew-loading-text { @include ew-loading-text; }
.ew-spinner { @include ew-spinner; }
.ew-table__actions { white-space: nowrap; }
.ew-table__link-btn {
  border: none; background: none; padding: 0; margin-right: 1rem;
  font-family: var(--app-font); font-size: 0.8rem; font-weight: 700;
  color: var(--app-accent-button);
  &:hover { text-decoration: underline; }
  &--danger { color: #C8102E; }
}

.ew-badge {
  display: inline-flex;
  align-items: center;
  height: 1.6rem;
  padding: 0 0.7rem;
  border-radius: 999px;
  font-family: var(--app-font);
  font-size: 0.75rem;
  font-weight: 700;

  &--success { background: rgba(26, 127, 79, 0.12); color: #1a7f4f; }
  &--pending { background: var(--app-surface-muted); color: var(--app-muted); }
}

.ew-empty { @include ew-empty; }
.ew-empty__title { @include ew-empty-title; }
.ew-empty__text { @include ew-empty-text; }

.ew-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 1rem 1.25rem;
  border-top: 1px solid var(--app-border);
}
.ew-pagination__btn { @include ew-pagination-btn; }
</style>



// WEBPACK FOOTER //
// src/components/ListPrepaid.vue